import {store} from './../../redux/';
import { call, put } from 'redux-saga/effects';
import { url } from './../../services/Url';
import CONSTANTS from '../../util/constants';
import APICallingService from '../../services/APICallingService';


const getDivisionsAPI = () => {
    return APICallingService.sendRequestForGet(url.getDivisions, (res) => {
    }, true);
}

function* getDivisions() {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDivisionsAPI);
        if (response && response?.callBackStatus?.toLowerCase() == 'success') {
            yield put({
                type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONS_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get divisions');
                yield put({ type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONS_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }


    }
    catch (e) {

        yield put({ type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONS_API_SUCCESS, payload: { value: 'Failed' } });

    }


}

const getDivisionByIDFunc = (value) => {

    let urlGet = url.getDivisionByID + value.id.toString();
    return APICallingService.sendRequestForGet(urlGet, (res) => {
    }, true);
}

function* getDivisionByID(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(getDivisionByIDFunc, action.payload.value);
        if (response && response?.callBackStatus?.toLowerCase() == 'success') {
            yield put({
                type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONSBYID_MANAGEMENT_API_SUCCESS, payload: { value: response.data }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Failed to get divisions');
                yield put({ type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONSBYID_MANAGEMENT_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        yield put({ type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONSBYID_MANAGEMENT_API_SUCCESS, payload: { value: 'Failed' } });
    }


}


const createDivisionsAPI = (value) => {

    let payload = {
        "divisionName": value.divisionName
    }
    return APICallingService.sendRequestForPostWithAuth(url.addDivision, payload, false, (res) => {
    }, true);
}

function* createDivisions(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(createDivisionsAPI, action.payload.value);
        if (response && response?.callBackStatus?.toLowerCase() != 'failed') {

            alert('Division no ' + response.data.division_id + " Added Successfully")

            yield put({
                type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONS_MANAGEMENT_API_CALL
            })
            yield put({
                type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.ADD_DIVISIONS_API_SUCCESS, payload: { value: response?.callBackStatus }
            })

        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Division Already Exists ,try with another Division name');
                yield put({ type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.ADD_DIVISIONS_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }


    }
    catch (e) {
        alert('Failed to add Division ,try with again');
        yield put({ type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.ADD_DIVISIONS_API_SUCCESS, payload: { value: 'Failed' } });
    }

}


const editDivisionsAPI = (value) => {

    let urlEdit = url.editDivision + value.division_id.toString();

    let payload;
    if (value?.is_active) {
        payload = {
            "divisionName": value.divisionName
        };
    }
    else {
        payload = {
            "divisionName": value.divisionName,
            "is_active": value.is_active
        };
    }

    return APICallingService.sendRequestForPut(payload, urlEdit, (res) => {
    }, true);
}

function* editDivisions(action) {

    try {

        let s = store.getState();

        yield put({ type: CONSTANTS.CONSTANTS_LOGIN.LOGIN_TOGGLE_LOADING_STATE, payload: { value: true } });

        const response = yield call(editDivisionsAPI, action.payload.value);

        if (response && response != null && response?.callBackStatus != 'Failed') {


            if (action.payload.value.is_active != null && action.payload.value.is_active == false) {
                alert('Divisions no ' + action.payload.value.division_id + " Deleted Successfully")
            }
            else {
                alert('Divisions no ' + action.payload.value.division_id + " Updated Successfully")
            }
            yield put({
                type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.GET_DIVISIONS_MANAGEMENT_API_CALL, payload: { value: response?.callBackStatus }
            })
            yield put({
                type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.EDIT_DIVISIONS_API_SUCCESS, payload: { value: response?.callBackStatus }
            })
        }
        else {
            if (response && response != null && response.Status != 405) {
                alert('Division already exists,Please Try Another division name');
                yield put({ type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.EDIT_DIVISIONS_API_SUCCESS, payload: { value: response?.callBackStatus } });
            }
        }
    }
    catch (e) {
        alert('Failed to update division ,try again');
        yield put({ type: CONSTANTS.CONSTANTS_DIVISIONS_MANAGEMENT.EDIT_DIVISIONS_API_SUCCESS, payload: { value: 'Failed' } });
    }
}

export { editDivisions, createDivisions, getDivisions, getDivisionByID };
